// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__zwJ56","row":"ProcedureTreatmentSummary_row__1naiS"};